import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { MenuProvider } from './context/menu-context';
import { MenuComponent } from './menu-component';

export function MenuFactory() {
    return (
        <BaseLayoutFactory>
            <MenuProvider>
                <MenuComponent />
            </MenuProvider>
        </BaseLayoutFactory>
    );
}
